import { usePublicInviteLink, useNotifications, useInvites, useLastEcard, useJoinModal } from "hooks";
import { SHARE_METHODS } from "enums";

const useInviteLinkCopy = ({ setOpenCopyConfirmationModal }) => {
  const { handleCopyPublicLink, isLoading } = usePublicInviteLink();
  const { addErrorNotification } = useNotifications();
  const { setShareType } = useInvites();
  const { isFlowRequired } = useLastEcard();
  const { openJoinModal } = useJoinModal();

  const copyPublicLink = async () => {
    if (isFlowRequired) {
      setShareType(SHARE_METHODS.LINK);
      openJoinModal();
      return true;
    }

    try {
      await handleCopyPublicLink();
      setOpenCopyConfirmationModal(true);
      return true;
    } catch {
      addErrorNotification();
      return false;
    }
  };

  return {
    copyPublicLink,
    isLoadingPublicLink: isLoading,
  };
};

export default useInviteLinkCopy;
